import { userMap } from "./user";

export const authMap: GenericObject = {
	user: userMap,
};
